import { Box, Modal } from "@mui/material";
import { ModalStyle } from "../../../../helpers/appHelpers";

type SalaryAdjustmentConfirmModalProps = {
	open: boolean;
	title: string;
	children: React.ReactNode;
	confirmText: string;
	confirmingText: string;
	confirming?: boolean;
	onConfirm: () => void;
	onCancel: () => void;
};

const SalaryAdjustmentConfirmModal = ({
	open,
	title,
	children,
	confirmText,
	confirmingText,
	confirming,
	onConfirm,
	onCancel,
}: SalaryAdjustmentConfirmModalProps) => {
	return (
		<Modal
			open={open}
			aria-labelledby="salary-adjustment-confirm-title"
		>
			<Box sx={{ width: 480, ...ModalStyle }}>
				<h2
					id="salary-adjustment-confirm-title"
					className="font-bold text-lg mb-4"
				>
					{title}
				</h2>
				<div className="text-sm text-gray-700 space-y-3">{children}</div>

				<div className="flex w-full justify-center space-x-4 items-center mt-10 text-center whitespace-nowrap">
					<button
						type="button"
						onClick={onCancel}
						className={`w-full lg:w-fit lg:px-12 py-4 border text-gray-400 hover:text-gray-500 border-gray-300 rounded-lg text-2xs ${confirming && "opacity-50"}`}
						disabled={confirming}
					>
						Cancel
					</button>
					<button
						type="button"
						onClick={onConfirm}
						className={`w-full lg:w-fit lg:px-12 py-4 border text-white hover:opacity-90 bg-primary-mango rounded-lg text-2xs ${confirming && "opacity-50"}`}
						disabled={confirming}
					>
						{confirming ? confirmingText : confirmText}
					</button>
				</div>
			</Box>
		</Modal>
	);
};

export default SalaryAdjustmentConfirmModal;
